import { useCallback, useRef } from 'react';

export function useSingleActiveMediaCoordinator() {
  const mediaElementsRef = useRef(new Map<string, HTMLMediaElement>());
  const activeBlockIdRef = useRef<string | null>(null);

  const registerMediaElement = useCallback((blockId: string, element: HTMLMediaElement | null) => {
    if (element) {
      mediaElementsRef.current.set(blockId, element);
      return;
    }

    mediaElementsRef.current.delete(blockId);
    if (activeBlockIdRef.current === blockId) {
      activeBlockIdRef.current = null;
    }
  }, []);

  const handleMediaPlay = useCallback((blockId: string) => {
    mediaElementsRef.current.forEach((element, registeredBlockId) => {
      if (registeredBlockId === blockId) return;
      element.pause();
    });

    activeBlockIdRef.current = blockId;
  }, []);

  const handleMediaStop = useCallback((blockId: string) => {
    if (activeBlockIdRef.current === blockId) {
      activeBlockIdRef.current = null;
    }
  }, []);

  return {
    registerMediaElement,
    handleMediaPlay,
    handleMediaStop,
  };
}
